module.exports = __webpack_public_path__ + "static/assets/33322bdd81cb20f267f2ca63fd973b81.svg";